<template>
  <div data-sidebar="group-content" :class="cn('tw-flex tw-flex-col tw-w-full tw-text-sm tw-gap-y-1', props.class)">
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/components/ui/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>
